import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "./sidebarSlice";
import categoryReducer from "./categorySlice";
import productReducer from "./productSlice";
import cartRecuder from'./cartSlice'
import searchReducer from './searchSlice'
const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
    category: categoryReducer,
    product:productReducer,
    cart: cartRecuder,
    search:searchReducer
  }
})

export default store;